let audioContext;

export const playNotificationTone = () => {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        audioContext = audioContext || new AudioContext();
        if (audioContext.state === "suspended") audioContext.resume().catch(() => {});
        const now = audioContext.currentTime;
        const gain = audioContext.createGain();
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(0.12, now + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.42);
        gain.connect(audioContext.destination);

        [659.25, 880].forEach((frequency, index) => {
            const oscillator = audioContext.createOscillator();
            oscillator.type = "sine";
            oscillator.frequency.setValueAtTime(frequency, now + index * 0.11);
            oscillator.connect(gain);
            oscillator.start(now + index * 0.11);
            oscillator.stop(now + 0.28 + index * 0.11);
        });
    } catch (error) {
        // Some browsers require a user gesture before audio can start.
    }
};
